import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType, IntermediaryGetAllResponse, IntermediaryDraftDataRow } from '@pmp/api';

export const INTERMEDIARY_TRADING_ADDRESSES_LIST = 'INTERMEDIARY_TRADING_ADDRESSES';

export const columns: TableColumns<IntermediaryGetAllResponse> = [
  {
    title: 'lender.brokers.labels.ohpenId',
    dataIndex: 'ohpenId',
    key: 'id',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
    fixed: 'left',
  },
  {
    title: 'lender.brokers.labels.fullName',
    dataIndex: 'displayName',
    key: 'displayName',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.email',
    dataIndex: 'email',
    key: 'email',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.roles',
    dataIndex: 'roles',
    key: 'roles',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.USER_ROLE_TYPE,
    },
  },
  {
    title: 'lender.brokers.labels.irnNumber',
    dataIndex: 'irn',
    key: 'irn',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.firmName',
    dataIndex: 'firmName',
    key: 'firmName',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.firmFRN',
    dataIndex: 'firmFRN',
    key: 'firmFRN',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.tradingAddress',
    dataIndex: 'tradingAddress',
    key: 'tradingAddress',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.complianceStatus',
    dataIndex: 'compliance',
    key: 'compliance',
    width: 130,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.COMPLIANCE_STATUS,
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.activationStatus',
    dataIndex: 'userStatus',
    key: 'userStatus',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.USER_STATUS,
    },
  },
  {
    title: 'lender.brokers.labels.activationDate',
    dataIndex: 'activationDate',
    key: 'activationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'lender.brokers.labels.deactivationDate',
    dataIndex: 'deactivationDate',
    key: 'deactivationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const intermediaryCRColumns: TableColumns<IntermediaryDraftDataRow> = [
  {
    title: 'lender.brokers.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 200,
    options: { sorter: true, hide: true },
  },
  {
    title: 'lender.brokers.labels.firmName',
    dataIndex: 'firmId',
    key: 'firmId',
    width: 200,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.FIRMS,
      allowSearch: true,
      required: true,
    },
  },
  {
    title: 'lender.brokers.labels.email',
    dataIndex: 'email',
    key: 'email',
    width: 200,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.title',
    dataIndex: 'title',
    key: 'title',
    width: 80,
    options: { sorter: true, format: { type: 'valueList' }, listName: FieldType.TITLES },
  },
  {
    title: 'lender.brokers.labels.firstName',
    dataIndex: 'firstName',
    key: 'firstName',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.lastName',
    dataIndex: 'lastName',
    key: 'lastName',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.currentStatus',
    dataIndex: 'userStatus',
    key: 'userStatus',
    width: 120,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.USER_STATUS,
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.roles',
    dataIndex: 'roles',
    key: 'roles',
    width: 120,
    options: {
      format: { type: 'multiValueList' },
      listName: FieldType.USER_ROLE_TYPE,
    },
  },
  {
    title: 'lender.brokers.labels.irnNumber',
    dataIndex: 'irn',
    key: 'irn',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.fcaStatus',
    dataIndex: 'fcaStatus',
    key: 'fcaStatus',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.dateOfBirth',
    dataIndex: 'birthDate',
    key: 'birthDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.previousName',
    dataIndex: 'previousName',
    key: 'previousName',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.mobile',
    dataIndex: 'mobilePhoneNumber',
    key: 'mobilePhoneNumber',
    width: 150,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.telephone',
    dataIndex: 'workPhoneNumber',
    key: 'workPhoneNumber',
    width: 150,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.tradingAddress',
    dataIndex: 'tradingAddressId',
    key: 'tradingAddressId',
    width: 200,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: INTERMEDIARY_TRADING_ADDRESSES_LIST,
      allowSearch: true,
    },
  },
  {
    title: 'lender.brokers.labels.complianceStatus',
    dataIndex: 'complianceStatus',
    key: 'complianceStatus',
    width: 140,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.COMPLIANCE_STATUS,
    },
  },
];
